import { Component, ElementRef, OnInit,ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators, Form } from "@angular/forms";
import { DoctypeService } from "src/app/doctype-section/doctype-service/doctype.service";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { take, single } from "rxjs/operators";
import { DoctorsService } from "../doctor-service/doctors.service";
import { MessageService, SelectItem } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { HospitalService } from "src/app/hospital-section/hospital.service";
@Component({
  selector: "app-doctors-register",
  templateUrl: "./doctors-register.component.html",
  styleUrls: ["./doctors-register.component.css"],
  providers: [MessageService]
})
export class DoctorsRegisterComponent implements OnInit {
  @ViewChild('cls',{static: false}) cref:ElementRef;
  count = 1;
  rgForm: FormGroup;
  piForm: FormGroup;
  di: Form;
  CouncilArray = [];

  ci: Form;
  doctorTypeAray = [];
  degrees: SelectItem[];
  clinicDays: SelectItem[];
  isDocType = false;
  countryArray = [];
  isCbDisabled = true;
  isSelectDefaultOption: boolean = false;
  docId: any;
  token: string;
  docData: any;
  Hospital:any;
  hospitalForm:FormGroup;
  HosArray:any;
  pageOfHos:number=1;
  pagesOfHos:any;
  Hosloading:any;
  hospitalClinicForm:FormGroup;


  constructor(
    private docService: DoctorsService,
    private authService: AuthService,
    private router: Router,
    private doctypeService: DoctypeService,
    private activaredRoute: ActivatedRoute,
    //edit by ayaan
    private hosService:HospitalService
  )  { 
    // setTimeout(() => {
    //   this.docId = false;
    // }, 3000);
  }

  ngOnInit(): void {
    this.authService.authDataSubject.pipe(take(1)).subscribe(res => {
      this.token = res._token;
    });
    this.docId = this.activaredRoute.snapshot.queryParams["id"];
    console.log(this.docId,'gtbgrbgrbgrbg')
    this.degrees = [
      { label: "MBBS", value: { name: "MBBS" } },
      { label: "BDS", value: { name: "BDS" } },
      { label: "MD", value: { name: "MD" } },
      { label: "MS", value: { name: "MS" } },
      { label: "BSC Nursing", value: { name: "BSC Nursing" } },
      { label: "B.Pharmacy", value: { name: "B.Pharmacy" } }
    ];
    this.clinicDays = [
      { label: "Sunday", value: { name: "Sunday" } },
      { label: "Monday", value: { name: "Monday" } },
      { label: "Tuesday", value: { name: "Tuesday" } },
      { label: "Wednesday", value: { name: "Wednesday" } },
      { label: "Thursday", value: { name: "Thursday" } },
      { label: "Friday", value: { name: "Friday" } },

      { label: "Saturday", value: { name: "Saturday" } }
    ];

    this.getDoctorType();
    this.getMedicalCouncil();
    if (this.docId) {
      this.getSingleDoc();
    }
    if (!this.rgForm) {
      this.initRgForm();
    }
    this.hospitalClinicForm = new FormGroup({
      weekDays: new FormControl(null,Validators.required),
      patientLimit: new FormControl(null,Validators.required),
      bookingType: new FormControl(null, Validators.required),
      startTime:new FormControl(null,Validators.required),
      endTime: new FormControl(null,Validators.required),
      hospitalId:new FormControl(null,Validators.required),
      district:new FormControl(null,Validators.required)
    });
    this.getHoslist();
  }
  getSingleDoc() {
    this.docService
      .getSingleDoctorFromDb(this.docId, this.token)
      .subscribe(res => {
        this.docData = res;
        console.log("this is doctor data",res);
        
        this.initRgForm();
      });
  }
  closemodal(){
    this.cref.nativeElement.click();
  }
  onPageNext() {
    /*  const name = this.rgForm.value["name"];
    const doctorType = this.rgForm.value["doctorType"];
    const email = this.rgForm.value["email"];
    const password = this.rgForm.value["password"];
   const degree = this.rgForm.value["degree"];

    const line1 = this.rgForm.value["line1"];
    const city = this.rgForm.value["city"];
    const pincode = this.rgForm.value["pincode"];
    const state = this.rgForm.value["state"];

    const clinic = this.rgForm.value["clinic"]
    const phoneNo = this.rgForm.value["phoneNo"];*/
    if (this.count < 5) {
      this.count = this.count + 1;
    }
  }
  onPreviousPage() {
    if (this.count > 1) {
      this.count = this.count - 1;
    }
  }
  initRgForm() {
    let name = null;
    let doctorType = null;
    let email = null;
    let line1 = null;
    let city = null;
    let state = null;
    let district = null;

    let pincode = null;
    let experience = null;
    let memberCouncil = null;
    let patientLimit = null;
    let consFee = null;
    let clinic = null;
    let phoneNo = null;
    let memberCouncilId = null;

    if (this.docData) {
      name = this.docData.name ? this.docData.name : null;
      doctorType = this.docData.doctorType ? this.docData.doctorType._id : null;
      email = this.docData.email ? this.docData.email : null;

      //  gender: new FormControl(null, Validators.required),

      line1 = this.docData.address.line1 ? this.docData.address.line1 : null;
      district = this.docData.address.district
        ? this.docData.address.district
        : null;
      city = this.docData.address.city ? this.docData.address.city : null;
      pincode = this.docData.address.pincode
        ? this.docData.address.pincode
        : null;
      (state = this.docData.address.state ? this.docData.address.state : null),
        (experience = this.docData.experience ? this.docData.experience : null),
        (memberCouncilId = this.docData.mcId ? this.docData.mcId : null);
      (patientLimit = this.docData.clinicId.patientLimit
        ? this.docData.clinicId.patientLimit
        : null),
        (consFee = this.docData.consultationFee.firstVisit
          ? this.docData.consultationFee.firstVisit
          : null),
        (clinic = this.docData.clinic ? this.docData.clinic : null);
      phoneNo = this.docData.phoneNo ? this.docData.phoneNo : null;
    }

    this.rgForm = new FormGroup({
      name: new FormControl(name, Validators.required),
      doctorType: new FormControl(doctorType, Validators.required),
      email: new FormControl(email, [Validators.required, Validators.email]),
      password: new FormControl(null, Validators.required),
      degree: new FormControl(null, Validators.required),
      //  gender: new FormControl(null, Validators.required),
      line1: new FormControl(line1, Validators.required),
      district: new FormControl(district, Validators.required),

      city: new FormControl(city, Validators.required),

      pincode: new FormControl(pincode, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/)
      ]),
      state: new FormControl(state, Validators.required),
      experience: new FormControl(experience, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/)
      ]),
      memberCouncil: new FormControl(memberCouncil, Validators.required),
      memberCouncilId: new FormControl(memberCouncilId, Validators.required),
      patientLimit: new FormControl(patientLimit, Validators.required),
      consFee: new FormControl(consFee, Validators.required),
      clinicDays: new FormControl(null, Validators.required),

      clinic: new FormControl(clinic, Validators.required),
      phoneNo: new FormControl(phoneNo, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
        Validators.minLength(10)
      ])
    });
  }

  getDoctorType() {
    this.doctypeService.getDocType("").subscribe(res => {
      this.doctorTypeAray = res;
      this.isDocType = true;
    });
  }
  getMedicalCouncil() {
    this.docService.getCouncilCountry().subscribe(res => {
      this.countryArray = res.council;
    });
  }
  onChangeCountry(con) {
    this.CouncilArray = [];
    this.isSelectDefaultOption = true;
    this.isCbDisabled = true;
    this.docService.getCouncilByCountry(con).subscribe(res => {
      this.CouncilArray = res.council.councilName;
      this.isCbDisabled = false;
    });
  }
  onSubmit() {
    const name = this.rgForm.value["name"];
    const doctorType = this.rgForm.value["doctorType"];
    const email = this.rgForm.value["email"];
    const password = this.rgForm.value["password"];
    let degree = this.rgForm.value["degree"];
    let district = this.rgForm.value["district"];

    const line1 = this.rgForm.value["line1"];
    const city = this.rgForm.value["city"];
    const pincode = this.rgForm.value["pincode"];
    const state = this.rgForm.value["state"];

    const clinic = this.rgForm.value["clinic"];
    const phoneNo = this.rgForm.value["phoneNo"];
    const experience = this.rgForm.value["experience"];
    const memberCouncil = this.rgForm.value["memberCouncil"];
    const patientLimit = this.rgForm.value["patientLimit"];
    const memberCouncilId = this.rgForm.value["memberCouncilId"];
    const consFee = this.rgForm.value["consFee"];
    let clinicDays = this.rgForm.value["clinicDays"];
    console.log(this.rgForm.valid);

    if (degree && degree.length > 0) {
      degree = degree.map(sin => {
        return sin.name;
      });
    }
    if (clinicDays && clinicDays.length > 0) {
      clinicDays = clinicDays.map(sin => {
        return sin.name;
      });
    }
    console.log(this.docId,'tid idds')
    if (this.docId) {
      this.docService
        .updateDoctorToDatabase(
          name,
          doctorType,
          email,
          degree,
          line1,
          city,
          pincode,
          state,
          clinic,
          phoneNo,
          this.token,
          this.docId,
          experience,
          consFee,
          memberCouncilId,
          memberCouncil,
          district
        )
        .subscribe(res=>{
          this.count = this.count + 1;
          this.settimeout();
        });
    } else {
      this.docService
        .RegisterDoctorToDatabase(
          name,
          doctorType,
          email,
          experience,
          degree,
          line1,
          city,
          pincode,
          state,
          memberCouncil,
          patientLimit,
          consFee,
          clinicDays,
          clinic,
          phoneNo,
          password,
          memberCouncilId,
          district
        )
        .subscribe(res => {
          this.count = this.count + 1;
          this.settimeout();
          // this.router.navigate(["../"], {
          //   relativeTo: this.activaredRoute
          // });
          // this.count = this.count + 1;
        });
    }
  }
  //Edit by ayaan 
  getHoslist(){
    if(!this.HosArray){
      this.Hosloading = true;
      this.hosService.getHospitalFromDb(this.token,this.pageOfHos).subscribe((res:any)=>{
        // this.pagesOfHos = res.data.pages;
        this.HosArray = res.patData;
        this.Hosloading = false;
        console.log("This is hospital list",res);
      })
    }
  }
  haveHospital(e:any){
    console.log("id",e.target.value);
    this.Hospital = this.HosArray.filter((o=>o._id == e.target.value));
    console.log("this is filter hospital",this.Hospital);
    this.hospitalForm = new FormGroup({
      clinicName: new FormControl(this.Hospital[0].name),
      line1: new FormControl(this.Hospital[0].address.address),
      city: new FormControl(this.Hospital[0].address.city),
      // district: new FormControl(),
      pincode: new FormControl(this.Hospital[0].address.pincode),
      state: new FormControl(this.Hospital[0].address.state),
    });
    console.log("this is form of clinic",this.hospitalForm.value);
    
  }
  submitClinic(){
    let state = [{ value:"AP", name:"Andhra Pradesh"},
    { value:"AR" , name:"Arunachal Pradesh"},
    { value:"AS", name:"Assam"},
    { value:"BR", name:"Bihar"},
    { value:"CG", name:"Chhattisgarh"},
    { value:"GA", name:"Goa"},
    { value:"GJ", name:"Gujrat"},
    { value:"HR", name:"Haryana"},
    { value:"HP", name:"Himachal Pradesh"},
    { value:"JH", name:"Jharkand"},
    { value:"KA", name:"Karnataka"},
    { value:"KL", name:"Kerla"},
    { value:"MP", name:"Madhya Pradesh"},
    { value:"MH", name:"Maharashtra"},
    { value:"MN", name:"Manipur"},
    { value:"ML", name:"Meghalaya"},
    { value:"MZ", name:"Mizoram"},
    { value:"NL", name:"Nagaland"},
    { value:"OD", name:"Odisha"},
    { value:"PB", name:"Punjab"},
    { value:"RJ", name:"Rajasthan"},
    { value:"SK", name:"Sikkim"},
    { value:"TN", name:"Tamil Nadu"},
    { value:"TS", name:"Telangana"},
    { value:"TR", name:"Tripura"},
    { value:"UP", name:"Uttar Pradesh"},
    { value:"UK", name:"Uttarakhand"},
    { value:"WB", name:"West Bengal"},
  ]
    let data= this.hospitalClinicForm.value;
    if (this.hospitalClinicForm.value.weekDays && this.hospitalClinicForm.value.weekDays.length > 0) {
      this.hospitalClinicForm.value.weekDays = this.hospitalClinicForm.value.weekDays.map((day) => {
        return day.name;
      });
    }
    let arr = {...this.hospitalForm.value,...data,...{doctorId:this.docId}};
    let s = state.filter(o=> o.value ==  arr.state);
    arr.state = s[0].value;
    this.hosService.addHosAsClinic(this.token,arr).subscribe((res:any)=>{
      console.log("Successs",res);
      window.alert("Successfully added hospital as a clinic")
      
    })
    console.log("this is data of clinic ",arr);
    
  }
  settimeout(){
    console.log('functio');
    setTimeout(() => {
      this.router.navigate(['pas/doctors'])
    }, 3000);

  }
}
